var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-subheader kt-grid__item",attrs:{"id":"kt_subheader"}},[_c('div',{staticClass:"kt-container",class:{ 'kt-container--fluid': true }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }